import SETTINGS from '../config';
const apiToken = `${SETTINGS.HOME}/api-auth/token`;

const CONSTANTS = {
  HOME: SETTINGS.HOME,
  API: {
    url: SETTINGS.HOME,
    apiTokenUrl: `${apiToken}/`,
    signUp: `${SETTINGS.HOME}/api-auth/signup/`,
  },
  METABASE: SETTINGS.METABASE,
  FIRST_BATCH_LENGTH: 100,
  emptyFilters: {
    q: '',
  },
  HELP_PHONE_NUMBER: '+5563981154678',
};

export default CONSTANTS;
